// fragments/nodeSettingDefaults.js

// Default node configuration
export const defaultNodeOptions = {
  // resizable: true,
  selectable: true,
  selected: false,
  // draggable: true,
  width: 70,
  height: 50
}

export const defaultNodeSettings = {
  style: {
    backgroundColor: '#808080',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: '#808080',
    borderRadius: '10px',
    color: '#333',
    fontSize: '20px',
    fontWeight: 'bold',
    padding: '10px',
    flexDirection: 'row',
  },
  sourcePosition: 'right',
  targetPosition: 'left',
  shape: 'default',
  icon: 'none',
  iconSize: '22',
  iconSpacing: '8px',
  titleDescSpacing: '0',
  offset: '0',
  feature: 'none',
  descFontSize: '14',
  descFontColor: '#333'
};

export const defaultEdgeSettings = {
  data: {
    connectorType:'bezier'
  },
  style: {
    stroke: '#bbbbbb',
    strokeWidth: 2,
    strokeDasharray: '0',
  },
  markerEnd: {
    type: 'arrowclosed', // Valid marker type
    color: '#cccccc',
    width: 0,
    height: 0,
  },
  pathOptions: {
    curvature: 0.8,
    offset: 20,
  },
  animated: false,
  // connectorType: 'smoothstep'
};